import { SSNVerificationFailedContainer } from 'src/containers';

export const SSNVerificationFailed = () => <SSNVerificationFailedContainer />;
